<template>
  <div class="positive-report-holder">
    <div class="columns is-multiline">
      <div class="column is-6">
        <b-field label="Selecionar data" class="has-text-left">
          <b-datepicker v-model="date" icon="calendar-today"> </b-datepicker>
        </b-field>
      </div>
      <div class="column is-6 has-text-right">
        <button
          class="button is-primary"
          style="margin-top: 25px"
          @click="getAndPrintPositiveReport"
          :disabled="!date"
        >
          Imprimir
        </button>
      </div>
      <div class="column is-12">
        <print-positive-report style="display: none"></print-positive-report>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP } from "../services/HttpServices";
import { EventBus } from "../helpers/EventBus";
import PrintPositiveReport from "../components/positiveReport/PrintPositiveReport";
import moment from "moment";

export default {
  name: "PositiveReport",
  components: { PrintPositiveReport },
  data: () => ({
    currentPage: 1,
    date: null
  }),
  methods: {
    getAndPrintPositiveReport() {
      this.getReport();
    },
    async getReport() {
      let reportData = await HTTP.get(
        "/deliveries/positiveReport?date=" +
          this.date.toISOString().split("T")[0]
      );

      let report = reportData.data;
      if (!report.productList.length || !report.petList.length) {
        this.alertCustomError();
      } else {
        EventBus.$emit("print:positiveReport", {
          products: report.productList,
          pets: report.petList,
          date: this.date
        });
      }
    },
    alertCustomError: function () {
      let date = moment(this.date).format("DD/MM/YYYY");

      this.$buefy.dialog.alert({
        title: "Nenhuma rastreabilidade",
        message:
            `Não encontramos nenhuma rastreabilidade no dia <b>${date}</b>.`,
        type: "is-warning",
        hasIcon: true,
        icon: "alert",
        iconPack: "mdi"
      });
    }
  },
  created() {
    this.$store.commit("setSelectedViewTitle", "Rastreabilidade positiva");
  }
};
</script>

<style lang="scss" scoped></style>
